export default "__VITE_ASSET__bv65W_pS__"